import { Injectable } from '@angular/core';
import { Platform } from '@ionic/angular';

declare const mitekscanner: any;

export enum MitekError {
  SET_MISNAP_DOC_TYPE_ERROR = 'SET_MISNAP_DOC_TYPE_ERROR',
  CANCELED_WITH_ERROR_CODE = 'CANCELED_WITH_ERROR_CODE',
  CAMERA_PERMISSION_DENIED = 'CAMERA_PERMISSION_DENIED'
}
@Injectable({
  providedIn: 'root'
})
export class MitekScannerService {
  constructor(private platform: Platform) {}

  capture(face: 'FRONT' | 'BACK' = 'FRONT') {
    return new Promise<string>((resolve, reject) => {
      if (this.platform.is('cordova')) {
        mitekscanner.capture(
          face,
          (response: string) => {
            resolve(response);
          },
          (error: any) => {
            reject(error);
          }
        );
      } else {
        resolve(null);
      }
    });
  }
}
